import React from "react";
import { Divider } from "@chakra-ui/layout";

export const Separator = () => {
  return <Divider color="indigoBlue" height="20px" orientation="vertical" />;
};
